import { IconButton, Tooltip } from '@mui/material';
import { House } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import SettingsMenuButton from './SettingsMenuButton';

export const ACCOUNT_PAGE_BG = `
  radial-gradient(ellipse at 0% 0%, rgba(8, 145, 178, 0.08), transparent 45%),
  radial-gradient(ellipse at 100% 0%, rgba(124, 58, 237, 0.06), transparent 45%),
  radial-gradient(ellipse at 50% 100%, rgba(255, 199, 90, 0.04), transparent 50%),
  linear-gradient(180deg, #f7f9ff 0%, #ffffff 60%, #f7f9ff 100%)
`;

export const ACCOUNT_CARD_SX = {
  borderRadius: '20px',
  border: '1px solid rgba(15, 23, 42, 0.06)',
  boxShadow:
    '0 14px 36px -14px rgba(15, 23, 42, 0.10), 0 0 0 1px rgba(15, 23, 42, 0.02)',
  background: '#ffffff',
  overflow: 'hidden',
  transition: 'box-shadow 0.3s ease, transform 0.3s ease',
};

export const AccountSettingsButton = ({ beforeNavigate }) => (
  <SettingsMenuButton
    beforeNavigate={beforeNavigate}
    buttonProps={{
      sx: {
        position: 'fixed',
        top: { xs: 16, md: 22 },
        right: { xs: 16, md: 22 },
        zIndex: 20,
        width: 46,
        height: 46,
        color: '#475569',
        borderRadius: '14px',
        background: 'rgba(15, 23, 42, 0.04)',
        border: '1px solid rgba(15, 23, 42, 0.08)',
        backdropFilter: 'blur(14px)',
        WebkitBackdropFilter: 'blur(14px)',
        transition: 'all 0.25s ease',
        '& svg': { transition: 'transform 0.5s ease' },
        '&:hover': {
          background: 'rgba(8, 145, 178, 0.08)',
          borderColor: 'rgba(8, 145, 178, 0.24)',
          color: '#0891b2',
        },
        '&:hover svg': { transform: 'rotate(45deg)' },
      },
    }}
  />
);

export const AccountHomeButton = () => {
  const navigate = useNavigate();

  return (
    <Tooltip title="Voltar para produtos">
      <IconButton
        onClick={() => navigate('/products')}
        aria-label="Voltar para produtos"
        sx={{
          alignSelf: 'flex-start',
          width: 44,
          height: 44,
          color: '#475569',
          border: '1px solid rgba(148, 163, 184, 0.4)',
          backgroundColor: '#fff',
          transition: 'all .2s ease',
          '&:hover': {
            background: '#0891b2',
            color: '#fff',
            borderColor: '#0891b2',
          },
        }}
      >
        <House size={22} strokeWidth={2.2} />
      </IconButton>
    </Tooltip>
  );
};
